var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChairsideLeftAddToList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Channels",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.6,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Chairside-education,-Home",
    transform: "translate(-33.000000, -450.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Search",
    transform: "translate(33.000000, 448.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 3.46446609,
    y1: 5.27207794,
    x2: 15.4852814,
    y2: 17.2928932,
    id: "Line-8",
    transform: "translate(9.500000, 11.500000) rotate(-315.000000) translate(-9.500000, -11.500000) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.9497475,
    y1: 4.75735931,
    x2: 3.92893219,
    y2: 16.7781746,
    id: "Line-2",
    transform: "translate(9.500000, 10.500000) rotate(-315.000000) translate(-9.500000, -10.500000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairsideLeftAddToList);
export default __webpack_public_path__ + "static/media/Chairside-Left-Add-to-list.d3e0e98e.svg";
export { ForwardRef as ReactComponent };